export enum AppTypes {
  APP = "app",
  PLUGIN = "plugin",
}